import { getBaseAdditionalDetailState } from '~/shared/fnolAdditionalQuestions'

export default () => ({
  contacts: [],
  selectedReporter: null,
  reporterOptsIntoEmail: null,
  reporterOptsIntoText: null,
  notes: [],
  dateOfLoss: '',
  dateOfNotification: new Date(),
  notificationMethod: 'phone',
  descriptionOfLoss: '',
  causeOfDamage: null,
  damageType: null,
  doesKnowSourceOfDamage: null,
  sourceOfDamage: null,
  propertyDamage: {
    damages: [],
    anyUnfinishedDamagedRooms: null,
    hasExteriorDamage: null,
    numberRoomsDamaged: null,
    numberStructuresDamaged: null,
    numberItemsDamaged: null,
    descriptionOfDamagedProperty: '',
  },
  additional: getBaseAdditionalDetailState(),
  attachments: [],
  contactsTabHasErrors: true,
  damageTabHasErrors: true,
  hasVisitedDamageTab: false,
  hasAttemptedReviewScreen: false,
  claimNumber: '',
  claimReferenceNumber: '',
  vendorAssignments: [],
  taskAssignments: [],
  showClaimSuccessDialog: false,
  partnerContactOptIns: [{
    task: 'water-mitigation',
    canContact: null,
  }, {
    task: 'hosta',
    canContact: null,
  }],
})
